/** "Full brief" drawer (screens §P4.2): every published headline and the macro path of the released rounds. */
import type { ContentCatalog, MarketView } from "@bsim/contracts";
import { fiscalYearLabel, formatRate } from "../format";
import { Link } from "../shell/history";
import { Drawer } from "../theme/Drawer";

export function FullBrief({ cohortId, market, catalog, onClose }: { readonly cohortId: string; readonly market: MarketView; readonly catalog: ContentCatalog; readonly onClose: () => void }) {
  return (
    <Drawer title="Full brief" onClose={onClose}>
      <p><Link href={`/c/${cohortId}/outlook`} className="gx-btn gx-btn--primary" onClick={onClose}>Open the outlook</Link></p>
      <h3 className="gx-h3" style={{ marginTop: 20 }}>Headlines</h3>
      {market.news.length === 0 ? <p className="gx-muted">{market.throughRoundNo === 0 ? "Headlines appear when the first year closes." : "No headlines were published for the years closed so far."}</p> : (
        <ul className="gx-brief-news">{market.news.map((n) => <li key={n.id}>{n.headline}</li>)}</ul>
      )}
      <h3 className="gx-h3" style={{ marginTop: 20 }}>Macro path</h3>
      {market.env.length === 0 ? <p className="gx-muted" data-testid="cockpit.brief.nopath">The rate path and unemployment appear here as each year closes.</p> : (
      <table className="gx-table gx-num">
        <thead><tr><th scope="col">Year-end</th><th scope="col">Policy rate</th><th scope="col">10-year yield</th><th scope="col">Unemployment</th></tr></thead>
        <tbody>
          {market.env.map((e) => (
            <tr key={e.month}>
              <th scope="row">{e.month === 0 ? "Start" : fiscalYearLabel(catalog, Math.ceil(e.month / 12))}</th>
              <td>{formatRate(e.ffRate, 2)}</td><td>{formatRate(e.curveRate["10y"], 2)}</td><td>{formatRate(e.unemploymentRate, 2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      )}
    </Drawer>
  );
}
